import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getForecastReport = async ({
  fromDate,
  toDate,
  companyCode,
  locationCode = "",
  salaryType = "",
  employeeCode = 0,
  departmentCode = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  try {
    if (!companyCode || !fromDate || !toDate) {
      throw new Error("Company code, From date, and To date are required");
    }

    const url = isAllCompanies
      ? Api_EndPoints.AllCompanies_GetForeCastReport
      : Api_EndPoints.ForeCastReport;

    let queryString = `CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&FromDate=${fromDate}&ToDate=${toDate}`;

    if (locationCode) {
      queryString += `&LocationCode=${locationCode}`;
    }

    if (salaryType) {
      queryString += `&SalaryType=${salaryType}`;
    }
    if (departmentCode) {
      queryString += `&DepartmentCode=${departmentCode}`;
    }

    if (employeeCode) {
      queryString += `&EmployeeCode=${employeeCode}`;
    }

    if (isAllCompanies && userId !== 0) {
      queryString += `&UserId=${userId}`;
    }

    const { data } = await http_payroll.get(
      `${url}?${queryString}`,
    );
    return data;
  } catch (error) {
    console.error("Error fetching forecast report:", error);
    throw error;
  }
};

export const useGetForeCastReportQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetForeCastReport
        : Api_EndPoints.ForeCastReport,
    ],
    queryFn: () => getForecastReport(input),
    refetchOnWindowFocus: false,
  });
};
